
import React, { useState, useEffect } from 'react';
import  { Link }  from"react-router-dom";

export default function Navbar() {
  const [ ,setIsOpen] = useState(false);

  function handleToggleNavbar() {
    setIsOpen(prevIsOpen => !prevIsOpen);
    document.body.classList.toggle('overflow-hidden');
  }

  useEffect(() => {
    return () => {
      document.body.classList.remove('overflow-hidden');
    };
  }, []);
      
     

    
  return (
    
    <>
    
    <div className="mainpic1">
      <img src="./images/rest1.png" alt="" />
    </div>
   
    <nav>
      <input type="checkbox" id="check"/>
      <label for="check"  class="checkbtn" onClick={handleToggleNavbar} >  
       <i class="fas fa-bars"></i>
      </label>
      <label className="logo"><img src="./images/logo.png" alt="" /></label>
      <ul>
        <li><Link to="/" >HOME</Link></li>
        <li><Link to="/product" >PRODUCT</Link></li>
        <li><Link to="/promo" >PROMO</Link></li>
        <li><Link to="/about">ABOUT</Link></li>
        <li><Link to="/Contact">CONTACT</Link></li>
        <li><Link to="/"><i class="fa-solid fa-search" sizes="32x32"></i></Link></li>
      </ul>
    </nav>

   
     
    </>
  );
}